import React, { useEffect } from 'react';
import { EDSBreadcrumb } from '@eds2-beta1-react/eds-breadcrumb';
import img from './../../assets/brain-scan.png';
const DataViewer = ({ selectedFile, parentData, onBackToChild, onBackToMain }) => {

    useEffect(() => {
        const handleBreadcrumbClick = (event) => {
            const { detail } = event;
            if (detail && detail.value === 'data') {
                onBackToMain();
            } else if (detail && detail.value === parentData.name) {
                onBackToChild();
            }
        };

        window.addEventListener('eds-breadcrumb-click', handleBreadcrumbClick);
        
        return () => {
            window.removeEventListener('eds-breadcrumb-click', handleBreadcrumbClick);
        };
    }, [onBackToMain, onBackToChild, parentData.name]);

    const viewerCardContents = [
        {
            image: img,
            imageName: "Brain MRI.xxx"
        },
         {
            image: img,
            imageName: "Brain MRI.xxx"
        },
         {
            image: img,
            imageName: "Brain MRI.xxx"
        },
        {
            image: img,
            imageName: "Brain MRI.xxx"
        },
        {
            image: img,
            imageName: "Brain MRI.xxx"
        },
        {
            image: img,
            imageName: "Brain MRI.xxx"
        },
        {
            image: img,
            imageName: "Brain MRI.xxx"
        },
        {
            image: img,
            imageName: "Brain MRI.xxx"
        },
        {
            image: img,
            imageName: "Brain MRI.xxx"
        }
        // Add more card contents as needed
    ];
   
    return (
        <div className="data-upload-container">
            <div className="upload-data-header fill--1">                
                <EDSBreadcrumb
                    options={[
                        { label: 'Data', value: 'data', url: '#', onClick: onBackToMain },
                        { label: parentData.name, value: parentData.name, url: '#', onClick: onBackToChild },
                        { label: selectedFile.name, value: selectedFile.name }
                    ]}
                ></EDSBreadcrumb>      
            </div>
            <div className='viewer-section flex'>
                <div className='viewer-left-container fill--2'>
                    <p className='u-mt0 text-bold'>Instances</p>
                    {viewerCardContents.map((content, index) => (
                        <div className="viewLeftCardPanel" key={index}> 
                            <eds-card variant="option-1" elevation="" notch-size="" width="fit-content" height="fit-content">          
                                <div slot="main-images" className='viewLeftCardImageSlot'>
                                    <img 
                                        src={content.image} 
                                        alt={`img${index}`} 
                                        className="viewLeftCardImage" 
                                    />
                                </div>
                                <div slot="main-content">
                                    <p className="u-m0 u-mb0">{content.imageName}</p>                               
                                </div>           
                            </eds-card>
                        </div>
                    ))}
                </div>
                <div className='viewer-middle-container fill--1'>
                    <div className='viewer-middle-header'>
                        <p className='u-mt0 u-mb0'>Brain MRI.xxx</p>
                    </div>
                </div>
                <div className='viewer-right-container fill--2'>
                    <p className='u-mt0 text-bold'>Information</p>
                    <div className="viewer-info-list">
                        <div><span>Image type</span> <span className='text-bold'>Original</span></div>
                        <div><span>Acquisition time</span> <span className='text-bold'>11h 57m 02s</span></div>
                        <div><span>Content time</span> <span className='text-bold'>11h 57m 02s</span></div>
                        <div><span>Series description</span> <span className='text-bold'>Sag T1 ARDL</span></div>
                        <div><span>Scanning sequence</span> <span className='text-bold'>SE</span></div>
                        <div><span>Study description</span> <span className='text-bold'>Voyager Spine Lumbar</span></div>
                        <div><span>Scan options</span> <span className='u-mt0 text-bold'>NA</span></div>
                        <div><span>MR acquisition type</span> <span className='text-bold'>3D</span></div>
                        <div><span>Angio flag</span> <span className='text-bold'>N</span></div>
                        <div><span>Slice thickness</span> <span className='text-bold'>5 mm</span></div>
                    </div>
                </div>
            </div> 
        </div>
    );
};

export default DataViewer;
